import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustBadges = ({ language }) => {
  const badges = {
    FR: [
      { icon: 'Shield', text: 'Conforme RGPD' },
      { icon: 'Lock', text: 'Données Médicales Sécurisées' },
      { icon: 'CheckCircle', text: 'Certifié ISO 27001' }
    ],
    EN: [
      { icon: 'Shield', text: 'GDPR Compliant' },
      { icon: 'Lock', text: 'Medical Data Secured' },
      { icon: 'CheckCircle', text: 'ISO 27001 Certified' }
    ],
    ES: [
      { icon: 'Shield', text: 'Conforme RGPD' },
      { icon: 'Lock', text: 'Datos Médicos Seguros' },
      { icon: 'CheckCircle', text: 'Certificado ISO 27001' }
    ],
    PL: [
      { icon: 'Shield', text: 'Zgodne z RODO' },
      { icon: 'Lock', text: 'Zabezpieczone dane medyczne' },
      { icon: 'CheckCircle', text: 'Certyfikat ISO 27001' }
    ]
  };

  const currentBadges = badges?.[language] || badges?.EN;

  return (
    <div className="flex flex-wrap items-center justify-center gap-4 mt-8 pt-6 border-t border-border">
      {currentBadges?.map((badge, index) => (
        <div
          key={index}
          className="flex items-center gap-2 text-muted-foreground"
        >
          <Icon name={badge?.icon} size={16} className="text-success" />
          <span className="text-xs font-medium">{badge?.text}</span>
        </div>
      ))}
    </div>
  );
};

export default TrustBadges;